export const disableUIClassName = 'atlas-disable-ui';